import React, { useState } from 'react';
import styled from 'styled-components';

import { useTheme } from '../../../Context/ThemeContext';
import { getColor, lightTheme, darkTheme } from '../../../Styles/theme';

import { ReactComponent as DownArrowSvgIcon } from '../../../image/DownArrow.svg';
import { ReactComponent as PlusSvgIcon } from '../../../image/Plus.svg';
import { ReactComponent as MenuSvgIcon } from '../../../image/Menu.svg';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

export default function LessonBox(props) {
  const {
    data,
    coachList,
    onClickEditLessonButton,
    onClickDeletedLesson,
    index,
    onClickChangeIndex,
  } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: data.id });
  const style = { transform: CSS.Transform.toString(transform), transition };

  const [isIconWrapper, setIsIconWrapper] = useState(false);
  const [isMenuHover, setIsMenuHover] = useState(false);

  // 수업 클릭시 //
  function onClickLesson() {
    onClickEditLessonButton(data);
  }

  // 위로이동 버튼 클릭시 //
  function onClickMoveUp(e) {
    e.stopPropagation();
    onClickChangeIndex('UP', index);
  }

  // 아래로이동 버튼 클릭시 //
  function onClickMoveDown(e) {
    e.stopPropagation();
    onClickChangeIndex('DOWN', index);
  }

  // 코치 이름 매핑 //
  function getTeacherNames() {
    if (!data.teacherIds || (coachList || []).length === 0) return '';

    const coachMap = new Map((coachList || []).map(c => [c.id, c.name]));

    return data.teacherIds.split(',').map(id => coachMap.get(parseInt(id))).filter(Boolean).join(' ');
  }

  const teacherNames = getTeacherNames();

  return (
    <TopLevelWrapper ref={setNodeRef} style={style} {...attributes}>
      <LessonBoxView
        onClick={onClickLesson}
        isUnvisible={true}
        $isDark={isDark}>
        <TextWrapper>
          <ArrowWrapper
            isHover={isIconWrapper}
            onMouseEnter={() => setIsIconWrapper(true)}
            onMouseLeave={() => { setIsIconWrapper(false); setIsMenuHover(false); }}>
            <ArrowImageWrapper onClick={onClickMoveUp}>
              <StyledUpArrowSvg style={{ color: theme.line }} $dimmed={isIconWrapper} isMenuHover={isMenuHover} />
            </ArrowImageWrapper>
            <StyledMenuIconSvg
              {...listeners}
              $isDragging={isDragging}
              $isVisible={isIconWrapper}
              preserveAspectRatio="none"
              onMouseEnter={() => setIsMenuHover(true)}
              onMouseLeave={() => setIsMenuHover(false)} />
            <ArrowImageWrapper onClick={onClickMoveDown}>
              <StyledDownArrowSvg style={{ color: theme.line }} $dimmed={isIconWrapper} isMenuHover={isMenuHover} />
            </ArrowImageWrapper>
          </ArrowWrapper>
          <ClassColorTag backgroundColor={getColor(data.color, isDark)}/>
          <LessonNameWrapper>
            <Text fontFmaily='NotoSansKR-Medium' fontSize={14} >{data.name}</Text>
            {
              teacherNames &&
              <Text fontFmaily='NotoSansKR-Regular' fontSize={12} color={theme.text} >{teacherNames}</Text>
            }
          </LessonNameWrapper>
        </TextWrapper>
        <StatusWrapper>
          <ImageWrapper>
            <StyledCloseIcon style={{ color: theme.line }} onClick={(e) => { e.stopPropagation(); onClickDeletedLesson(data); }} />
          </ImageWrapper>
        </StatusWrapper>
      </LessonBoxView>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 512px;
`;

const LessonBoxView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 10px 12px;

  box-sizing: border-box;
  width: 512px;
  height: 62px;
  min-height: 62px;

  color: ${props => props.theme.text};

  border-radius: 12px;
  border: 1px solid ${props => props.theme.subBackground};
  background-color: ${props => props.theme.subBackground};
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.03);

  transition: all 0.3s ease-in-out;

  &:hover {
    color: ${props => props.isUnvisible ? props.theme.text : `#FFFFFF`};
    cursor: pointer;
    border: 1px solid ${props => props.theme.primary};
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 100%;
  height: 100%;

  overflow: hidden;
`;

const LessonNameWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  gap: 2px;

  overflow: hidden;
`;

const Text = styled.div`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.cursor};
  }
`;

const StatusWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 10px;
`;

const ImageWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  gap: 6px;
`;

const StyledCloseIcon = styled(PlusSvgIcon)`
  width: 20px;
  height: 20px;

  transform: rotate(45deg);

  transition: color 0.3s ease-in-out;

  &:hover {
    cursor: pointer;

  }
`;

const ArrowWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 20px;
  height: 42px;

  gap: 10px;
`;

const ArrowImageWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 20px;
  height: 6px;

  &:hover {
    cursor: pointer;
  }
`;

const StyledUpArrowSvg = styled(DownArrowSvgIcon)`
  width: 20px;
  height: auto;

  transform: ${props => props.$dimmed ? 'rotate(180deg) translateY(-5px)' : 'rotate(180deg) translateY(-13px)'};

  opacity: ${props => props.isMenuHover ? 0.2 : 1};
  transition: color 0.3s ease-in-out, opacity 0.3s ease-in-out, transform 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover path {
      stroke: ${props => props.theme.primary};
    }
  }
`;

const StyledDownArrowSvg = styled(DownArrowSvgIcon)`
  width: 18px;
  height: auto;

  transform: ${props => props.$dimmed ? 'translateY(-5px)' : 'translateY(-13px)'};

  opacity: ${props => props.isMenuHover ? 0.2 : 1};
  transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;

  & path {
    transition: stroke 0.3s ease-in-out;
  }

  @media (hover: hover) {
    &:hover path {
      stroke: ${props => props.theme.primary};
    }
  }
`;

const StyledMenuIconSvg = styled(MenuSvgIcon)`
  flex-shrink: 0;

  width: ${props => props.$isDragging ? '12px' : '10px'};
  height: 18px;

  cursor: grab;
  touch-action: none;

  opacity: ${props => props.$isVisible ? 1 : 0};
  transition: opacity 0.3s ease-in-out;

  & rect {
    fill: ${props => props.$isDragging ? props.theme.primary : props.theme.line};
    transition: fill 0.3s ease-in-out;
  }

  @media (hover: hover) {
    &:hover {
      width: 12px;
      height: 18px;
    }
    &:hover rect {
      fill: ${props => props.theme.primary};
    }
  }

  &:active {
    cursor: grabbing;
  }
`;

const ClassColorTag = styled.div`
  display: flex;
  flex-direction: row;

  margin: 0 10px 0 20px;

  width: 5px;
  height: 100%;

  border-radius: 2px;
  background-color: ${props => props.backgroundColor};
`;
